module.exports = __webpack_public_path__ + "media/customizations/regencyathollysprings/logo-new-bb7d2cf332e9ea81b83450b509b9b64c.png";